import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.css";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers/index";
import ReduxPromise from "redux-promise";
import registerServiceWorker from "./registerServiceWorker";
import logger from "redux-logger";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ReactGA from "react-ga";
import FormContainer from "./components/FormContainer";
import Home from "./components/home";

ReactGA.initialize("UA-128110139-1");


const Raven = require("@sentry/browser");
Raven.init({
  dsn: "https://067176aa71fd42929622d2b474ebbb0e@sentry.io/1298523",
  release: "collector.agfc.com@v1"
});

const createStoreWithMiddleware = applyMiddleware(ReduxPromise, logger)(
  createStore
);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <BrowserRouter>
      <Switch>
        <Route path="/new" component={FormContainer} />
        <Route path="/" component={Home} />
      </Switch>
    </BrowserRouter>
  </Provider>,

  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js